const seoConfig = () => () => ({
  pageType: 'search#index',
  title: 'Hackster.io - The community dedicated to learning hardware.',
});

export default seoConfig;
